// Detect iOS Safari (not in standalone), so we can prompt the user to install.

export function isIOSSafari(): boolean {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent;
  const isIOS = /iPad|iPhone|iPod/.test(ua) || (ua.includes('Mac') && 'ontouchend' in document);
  if (!isIOS) return false;
  const isStandalone =
    (window.matchMedia && window.matchMedia('(display-mode: standalone)').matches) ||
    // @ts-expect-error iOS-only
    !!window.navigator.standalone;
  return !isStandalone;
}
